import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../helper/proccessErrorMessage";
import { API_GET_INVESTMENT_PORTFOLIO } from "../../../config/api";
import mixpanel from "mixpanel-browser";

export const getPortfolio = createAsyncThunk(
  "portfolio/getList",
  async ({ currency, cb }, { rejectWithValue }) => {
    try {
      const response = await Client({
        method: "GET",
        path: API_GET_INVESTMENT_PORTFOLIO + currency,
      });
      if (cb) cb();
      return response?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      // mixpanel.track("Error", {
      //   type: "portfolio",
      //   subtype: "get-my-portfolio",
      //   message: msg,
      // });
      if (cb) cb();
      // toast.error(msg);
      throw error;
    }
  }
);
